<script>
  import { onMount, onDestroy } from "svelte";
  import { h3_MapBoxZoom } from "../scripts/mapScripts/h3_MapBoxZoom";
  import { radioCheck } from "./store.js";
  import { polygonToCells } from "h3-js";
  import { serverURL, districtAccess, districtFeatures } from "./store.js";
  export let Draw;
  import Papa from "papaparse";
  import * as turf from "@turf/turf";

  import { districts_data } from "./data/district_data.js";
  import { dist_lt_15k } from "./data/dis_lt_15k.js";
  import { area } from "turf";
  import * as d3 from "d3";
  export let map;

  let name;
  let dots = "";
  let areaData;
  let areaLat;
  let areaLng;
  function mergeToMultiPolygon(tileFeatures) {
    if (!tileFeatures.length) return null;

    // 1. Wrap the pieces in a FeatureCollection
    const fc = {
      type: "FeatureCollection",
      features: tileFeatures.map((f) => ({
        type: "Feature",
        geometry: f.geometry, // Mapbox feature geometry is already valid GeoJSON
        properties: {},
      })),
    };

    // 2. turf.combine dissolves identical-type geometries into one MultiPolygon
    //    (If all inputs are Polygons or MultiPolygons, the first feature of
    //     the output will be a MultiPolygon.)
    const combined = turf.combine(fc);

    // combined.features[0] is the unified shape
    return combined.features[0];
  }
  // Update dots every 500ms
  const interval = setInterval(() => {
    dots = dots.length < 3 ? dots + "." : "";
  }, 500);
  $: if ($districtAccess[0]) {
    fetch("/data/area.csv")
      .then((res) => res.text())
      .then((csvText) => {
        const parsed = Papa.parse(csvText, {
          header: true, // tells Papa to use first row as keys
          skipEmptyLines: true,
        });
        const filteredData = parsed.data.filter(
          (d) => d.LAD24NM === $districtAccess[0]
        )[0];
        areaData = filteredData.area;
        areaLat = filteredData.LAT;
        areaLng = filteredData.LONG;
      });
  }
  // Clear interval when the component is destroyed
  onDestroy(() => {
    clearInterval(interval);
  });
  onMount(() => {
    let layers;
    if ($districtAccess[0] == "All") {
      layers = districts_data.sort((a, b) => a.name.localeCompare(b.name));
    } else {
      layers = districts_data
        .filter((layer) => $districtAccess.includes(layer.name))
        .sort((a, b) => a.name.localeCompare(b.name));
      console.log(layers);
    }

    function populateDropdown() {
      const dropdownItems = document.getElementById("dropdownItems");
      if (!dropdownItems) {
        return;
      }
      layers.forEach((layer) => {
        const a = document.createElement("a");
        a.href = "#";
        a.textContent = layer.name;
        a.style.color = "black";
        a.style.padding = "12px 16px";
        a.style.textDecoration = "none";
        a.style.display = "block";
        a.classList.add("dropdown-item");

        a.addEventListener("click", () => {
          name = layer.name;
          h3_MapBoxZoom(map, name, $radioCheck, $serverURL);
        });
        dropdownItems.appendChild(a);
      });
      const style = document.createElement("style");
      style.innerHTML = `
  .dropdown-item:hover {
    background-color: #ddd;
    color: black;
  }
`;
      document.head.appendChild(style);
    }

    populateDropdown();
    setTimeout(() => {
      if (
        $districtAccess.length == 1 &&
        $districtAccess[0] != "All" &&
        areaData <= 200
      ) {
        h3_MapBoxZoom(map, $districtAccess[0], $radioCheck, $serverURL);
      } else {
        map.flyTo({
          center: [areaLng, areaLat - 0.011],
          zoom: 8,
          essential: true,
        });

        map.once("moveend", function () {
          setTimeout(() => {
            let features = map.queryRenderedFeatures({
              layers: ["counties"],
              filter: ["==", "NAME", $districtAccess[0]],
            });
            console.log(features);
            districtFeatures.set(mergeToMultiPolygon(features));
            console.log($districtFeatures);
          });
        });
        map.setPaintProperty("counties", "line-color", [
          "case",
          ["==", ["get", "NAME"], $districtAccess[0]],
          "pink", // if NAME matches
          "transparent", // otherwise
        ]);
      }
    }, 1000);

    if (document.getElementById("searchBox")) {
      document
        .getElementById("searchBox")
        .addEventListener("keyup", function () {
          const filter = this.value.toLowerCase();
          const dropdownItems = document.querySelectorAll(".dropdown-item");
          dropdownItems.forEach(function (item) {
            if (item.textContent.toLowerCase().includes(filter)) {
              item.style.display = "block";
            } else {
              item.style.display = "none";
            }
          });
        });
    }
  });
</script>

<div id="loading">Loading{dots}</div>

{#if $districtAccess.length > 1 || $districtAccess[0] == "All"}
  <div class="dropdown">
    <button class="dropbtn">Select District</button>
    <div class="dropdown-content">
      <input
        type="text"
        placeholder="Search.."
        class="search-box"
        id="searchBox"
      />
      <div id="dropdownItems"></div>
    </div>
  </div>
{/if}

<style>
  #loading {
    opacity: 0;
    display: inline-block;
    position: absolute;
    z-index: 100000;
    color: white;
    left: 285px;
    margin-top: 5px;
  }
  .dropdown {
    position: absolute;
    display: inline-block;
    margin: 20px;
    z-index: 100000;
    left: 50%;
  }
  #dropdownItems {
    font-size: 12px;
  }
  .dropdown-content {
    left: -25px;
    user-select: none;
    display: none;

    position: absolute;
    background-color: #f9f9f9;
    min-width: 160px;
    max-height: 200px;
    overflow-y: auto;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 1;
  }

  .dropdown-content div:hover {
    background-color: #f1f1f1;
  }

  .dropdown:hover .dropdown-content {
    display: block;
  }

  .dropdown:hover .dropbtn {
    background-color: rgb(55, 146, 144);
  }

  .search-box {
    width: 100%;
    padding: 5px;
    box-sizing: border-box;
  }

  .dropbtn {
    background-color: rgb(69, 188, 187);
    font-family: "Poppins";
    color: #333;
    border-radius: 10px;
    outline: none;
    font-size: 14px;
  }
</style>
